import type { StateCreator, StoreApi } from 'zustand';
import { persist, createJSONStorage, type PersistOptions } from 'zustand/middleware';
import secureStorage from '@/utils/secureStorage';

const securePersist = <S>(
  config: StateCreator<S, [['zustand/devtools', never], ['zustand/persist', unknown]]>,
  options: Omit<PersistOptions<S>, 'storage'>,
) =>
  persist(
    (set, get, api) =>
      config(
        (partial, replace, actionName) => {
          const storeApiWithDevtools = api as StoreApi<S> & {
            devtools?: { send?: (action: string, state: S) => void };
          };

          if (storeApiWithDevtools.devtools && actionName && storeApiWithDevtools.devtools.send) {
            storeApiWithDevtools.devtools.send(actionName as string, get());
          }
          set(partial, replace as false | undefined);
        },
        get,
        api,
      ),
    { storage: createJSONStorage(() => secureStorage), ...options },
  );

export default securePersist;
